import { Component, ViewChild, ViewEncapsulation} from '@angular/core';
import { HcSort, HcTableDataSource, PaginationComponent } from "@healthcatalyst/cashmere";
import { Subject, takeUntil } from 'rxjs';
import { ChangeElement, ChangeService } from '../../shared/services/change.service';

/** Displays the Change Log for Terminology */
@Component({
    selector: 'pd-admin-terminology-change-log',
    templateUrl: './admin-terminology-change-log.component.html',
    styleUrls: ['./admin-terminology-change-log.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminTerminologyChangeLogComponent {
    private unsubscribe = new Subject<void>();
    loading = true;
    loadError = false;
    adminTerminologyChangesDataSource: HcTableDataSource<ChangeElement> = new HcTableDataSource();
    changesDisplayedColumns: string[] = ['date', 'item', 'user', 'field', 'previous', 'change'];
    changesPageSize: number = 10;
    
    @ViewChild(HcSort)
    sort: HcSort;

    @ViewChild(PaginationComponent)
    paginator: PaginationComponent;

    get changesListLength(): number {
        return this.adminTerminologyChangesDataSource.filteredData ? this.adminTerminologyChangesDataSource.filteredData.length : 0;
    }

    constructor ( private changeService: ChangeService ) {}

    ngOnInit(): void {
        this.loadTermChanges();
    }

    loadTermChanges(): void {
        this.loading = true;
        this.loadError = false;

        this.changeService
            .load({
                "categories": "terminology"
            })
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
                next: data => {
                    this.adminTerminologyChangesDataSource = new HcTableDataSource(data);
                    if ( this.sort && this.paginator ) {
                        this.adminTerminologyChangesDataSource.sort = this.sort;
                        this.adminTerminologyChangesDataSource.paginator = this.paginator;
                    }

                    setTimeout(() => {
                        this.sort.sort( { disableClear: false, id: 'date', start: 'desc' } );
                    });
                    
                    this.loadError = false;
                    this.loading = false;
                },
                error: msg => {
                    this.loadError = true;
                    this.loading = false;
                    console.log(msg);
                }
            });
    }
}